class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
		this.classList.remove('open');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerMain = this.closest('.header');
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.toggleClass.bind(this));
    if (window.innerWidth > 990) {
  this.addEventListener('mouseenter', () => {
    this.mainDetailsToggle.setAttribute('open', '');
  });

  this.addEventListener('mouseleave', () => {
  setTimeout(() => {
    if (!this.matches(':hover')) {
      this.close();
    }
  }, 300);
});
}
  }

	toggleClass() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.header.classList.add('open');
      this.headerMain.classList.add('open');
      this.mainDetailsToggle.classList.add('open');
    } else {
      this.header.classList.remove('open');
      this.headerMain.classList.remove('open');
      this.mainDetailsToggle.classList.remove('open')
    }
	}

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
